import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export default [
  {
    path: LOGIN_PATH,
    layout: false,
    component: "./LoginPage",
  },
  {
    path: OIDC_CALLBACK_PATH,
    layout: false,
    component: "./OidcCallbackPage",
  },
  {
    path: "/",
    redirect: "/schemes",
  },
  {
    path: "/members",
    name: "microLabMembers",
    icon: "team",
    access: "canManageMicroLabMembers",
    component: "./MembersPage",
  },
  {
    path: "/schemes",
    name: "microLabSchemes",
    icon: "project",
    access: "canAccessMicroLabTeacherWorkspace",
    component: "./SchemesPage",
  },
  {
    path: "/schemes/reviews",
    name: "microLabSchemeReviews",
    icon: "audit",
    access: "canReviewMicroLabLibrary",
    component: "./LibraryReviewsPage",
  },
  {
    path: "/schemes/:schemeCode/versions",
    access: "canAccessMicroLabTeacherWorkspace",
    hideInMenu: true,
    component: "./SchemeVersionsPage",
  },
  {
    path: "/releases/create",
    access: "canAccessMicroLabTeacherWorkspace",
    hideInMenu: true,
    component: "./ReleaseCreatePage",
  },
  {
    path: "/releases/:releaseCode",
    access: "canAccessMicroLabTeacherWorkspace",
    hideInMenu: true,
    component: "./ReleaseDetailPage",
  },
  {
    path: "/releases",
    name: "microLabReleases",
    icon: "notification",
    access: "canAccessMicroLabTeacherWorkspace",
    component: "./ReleasesPage",
  },
  {
    path: "/runs",
    name: "microLabRuns",
    icon: "dashboard",
    access: "canAccessMicroLabTeacherWorkspace",
    component: "./RunsPage",
  },
  {
    path: "*",
    component: "./NotFoundPage",
  },
];
